export default {
    heading: {
        label: 'Naziv rasporeda',
        placeholder: 'Unesite naziv rasporeda',
        tool_tip_message: 'Unesite naziv rasporeda. Možete uneti ime osobe zadužene za raspored.',
    },
    from_date: {
        label: 'Datum početka',
        placeholder: 'Unesite datum',
        tool_tip_message: 'Prvi dan rasporeda',
    },
    to_date: {
        label: 'Datum kraja',
        placeholder: 'Unesite datum',
        tool_tip_message: 'Poslednji dan rasporeda',
    },
    max_days: {
        label: 'Dozvoli rezervaciju dana unapred',
        placeholder: 'Unesite broj',
        tool_tip_message: 'Maksimalan broj dana za rezervaciju slota unapred',
    },
}
